import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  cardWrapper: {
    margin: '24px 40px',
    padding: '20px',
  },
  multiFieldValues: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between'
  },
  contentWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    margin: '8px 5px',
  },
  eventConfigWrapper: {
    display: 'flex',
    width: '100%',
    alignItems: 'baseline'
  },
  programFlagWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '50%',
    justifyContent: 'center'
  },
  programsHeaderWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '30px 40px 24px',
    flexWrap: 'wrap'
  },
  headerWrapper: {
    backgroundColor: '#F7F7F7',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0.8em',
    margin: '1.5em 1.5em 0em 1.5em',
    color: '#F37320',
    fontSize: '1em',
    fontWeight: 'bold',
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px',
  },
  titleWrapper: {
    margin: '30px 40px 24px',
  },
  createWrapper: {
    padding: '6px 32px 32px',
    margin: '0px 40px',
  },
  formWrapper: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',

    '@media (min-width: 768px)': {
      flexDirection: 'row',
    }
  },
  formContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',

    '@media (min-width: 768px)': {
      width: '50%',
    }
  },
  fieldWrapper: {
    display: 'flex',
    flexDirection: 'column'
  },
  field: {
    marginTop: '24px',
    width: '100%',

    '@media (min-width: 768px)': {
      width: '70%',
    }
  },
  underline: {
    '&::before': {
      borderColor: 'rgba(0, 0, 0, 0.42)',
    },
  },
  errorMessage: {
    color: 'red',
    fontSize: '12px',
    marginTop: '5px'
  },
  error: {
    color: 'red',
  },
  input: {
    fontSize: '14px',
    color: '#545455',
    '& svg': {
      '@media (min-width: 3000px)': {
        top: 'calc(50% - 20px)'
      }
    }
  },
  maxEventDurationInput: {
    fontSize: '14px',
    color: '#545455',
    width: '50%',
  },
  shrink: {
    color: '#6F6F8C',
    fontSize: '16px',
  },
  programEndDate: {
    color: '#6F6F8C',
    fontSize: '14px',
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '30px',
    width: '30%',
    justifyContent: 'space-between',
    marginLeft: 'auto',
    marginTop: '22px',
    marginBottom: '22px',

    '@media (max-width: 767px)': {
      width: '100%'
    }
  },
  saveButtonWrapper: {
    display: 'flex',
    marginTop: '22px',
    alignItems: 'center',
    marginLeft: 'auto',
    marginRight: '22px',
    justifyContent: 'flex-end',
    '@media (max-width: 767px)': {
      width: '100%'
    }
  },
  saveButton: {
    width: '150px',
    height: '36px',
    textTransform: 'capitalize',
    margin: 0,
    borderRadius: '4px',
  },
  button: {
    width: '45%',
    height: '36px',
    textTransform: 'capitalize',
    margin: 0,
  },
  hr: {
    marginTop: '100px',
    borderColor: '#D8DCDE',
  },
  programDetailsTitle: {
    margin: '1% 2% 1% 2%',
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '2.5em',
    padding: '0',
  },
  programDetailsViewer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  programDetailsBody: {
    margin: '0% 2% 1% 2%',
    padding: '0',
    height: '35%',
  },
  programFilesBody: {
    margin: '0% 2% 1% 2%',
    padding: '0',
    height: '45%',
  },
  programFilesOptions: {
    margin: '2.5%',
    height: '50%',
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap'
  },
  programFilesAction: {
    border: '1px dashed #CECECE',
    borderRadius: '5px',
    width: '13em',
    height: '12em',
    alignItems: 'center',
    margin: '0% 1% 1% 0%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    backgroundColor: '#F6F6F6',
    '&:hover': {
      backgroundColor: '#FFF',
      cursor: 'pointer',
    },
  },
  programFilesPublishIcon: {
    color: '#F37320',
    height: '3.125rem',
    width: '3.125rem',
    marginTop: '0.625rem',
  },
  programDetailsCard: {
    width: 'auto',
    display: 'flex',
    flexGrow: '1',
    justifyContent: 'space-around',
  },
  programDetailsCardValue: {
    width: '100%',
    margin: '2em',
    display: 'flex',
    flexDirection: 'column',
  },
  programConfigurationCardValue: {
    margin: '2em',
  },
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  options: {
    background: '#fff !important',
    padding: '0px 12px !important'
  },
  autocompleteOptions: {
    color: '#6F6F6F',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  checkbox: {
    color: '#F37320',
    padding: 0
  },
  tagWrapper: {
    display: 'flex',
    color: '#545455',
    fontSize: '14px'
  },
  dollar: {
    color: '#545455',
    fontSize: '14px',
    marginRight: '4px'
  },
  popWrapper: {
    padding: '30px',
    color: '#565657',
    fontSize: '16px',
    textAlign: 'center'
  },
  ackButton: {
    marginTop: '20px',
    width: 'auto',
    height: 'auto'
  },
  popText: {
    fontSize: '18px'
  },
  labelWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  infoIcon: {
    width: '16px',
    height: '16px',
    marginLeft: '3px',
    cursor: 'pointer',
    zIndex: 99
  },
  infoWrapper: {
    background: '#FFFFFF !important',
    boxShadow: '0px 0px 6px #00000029',
    borderRadius: '8px',
    padding: '12px 18px',
    maxWidth: '250px'
  },
  infoText: {
    color: '#6F6F6F',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  programDetailsCardCell: {
    flex: '1',
    display: 'flex',
    justifyContent: 'space-between',
  },
  programDetailsCardCellKey: {
    fontSize: '14px',
    color: '#6F6F6F',
    opacity: '60%'
  },
  programDetaislCardCellValue: {
    fontSize: '14px',
    color: '#6F6F6F',
    fontWeight: 'bold',
    wordBreak: 'break-word'
  },
  disable: {
    opacity: '50%',
    pointerEvents: 'none'
  },
  tableRightAlign: {
    textAlign: 'right'
  },
  tabelLastCol: {
    '& p': {
      width: '100px',
      textAlign: 'right'
    }
  },
  tabelStatusCol: {
    '& p': {
      width: '100px',
      textAlign: 'left'
    }
  },
  tableHeading: {
    '& span': {
      fontSize: '14px'
    },
  },
  programName: {
    width: '25%',

    '& button': {
      marginLeft: '20px'
    }
  },
  accountName: {
    width: '15%'
  },
  systems: {
    width: '15%'
  },
  events: {
    width: '100px',
    '& button': {
      width: '100px',
      justifyContent: 'flex-end'
    }
  },
  status: {
    width: '100px',
    '& button': {
      width: '100px',
      justifyContent: 'start'
    }
  },
  marginRight: {
    '& p': {
      marginRight: '18%'
    }
  },
  systemsEnrolled: {
    '& p': {
      maxWidth: '150px'
    }
  },
  crossIcon: {
    cursor: 'pointer',
    '& svg': {
      width: '15px',
      height: '15px',
    }
  },
  formHeadingWrapper: {
    backgroundColor: '#F7F7F7',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0.8em',
    margin: '1.5em 0 0',
    color: '#F37320',
    fontSize: '1em',
    fontWeight: 'bold',
  },
  formSwitch: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '97%',
    marginLeft: '5px',
  },
  adminSwitch: {
    width: '80%'
  },
  programFlagCell: {
    display: 'flex',
    justifyContent: 'center',
    marginRight: '0px'
  },
  helperText: {
    fontSize: '12px',
    color: '#f44336',
  },
  switchLabel: {
    fontSize: '14px !important',
    color: '#6F6F6F',
    opacity: '60%',
  },
  textField: {
    width: '250px',
    marginLeft: '1.5rem'
  },
  checkBoxleave: {
    width: '300px',
    justifyContent: 'flex-start',
    paddingLeft: '20px'
  },
  labelSubheading: {
    fontSize: '14px !important',
    color: '#6F6F6F',
    opacity: '60%',
    margin: '20px 10px 20px 5px'
  },
  subHeading: {
    color: '#6F6F6F',
    opacity: '84%',
    fontSize: '14px',
    margin: '8px 5px',
    fontWeight: 'bold'
  },
  enrolmentButton: {
    margin: '5px',
    textTransform: 'none',
    '&:hover': {
      background: 'transparent'
    }
  },
  buttonText: {
    color: '#707070',
  },
  moduleContainer: {
    backgroundColor: '#FCFCFC',
    padding: '5px',
    margin: '0px 0px 10px'
  },
  programConfigSubHeading: {
    color: '#6F6F6F',
    opacity: '84%',
    fontSize: '14px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center'
  },
  moduleIcons: {
    marginRight: '10px',
    width: '20px',
    height: '20px'
  },
  icons: {
    cursor: 'pointer'
  },
  eventTypeBox: {
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    border: '1px solid #F0F0F0',
    borderRadius: '7px',
    opacity: 1,
    margin: '5px 0',
    padding: '10px 5px',
    fontSize: '12px',
    color: '#818181',
    maxWidth: '150px',
    fontWeight: 600
  },
  eventSubTypeBox: {
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    border: '1px solid #F0F0F0',
    borderRadius: '7px',
    opacity: 1,
    margin: '5px',
    padding: '8px',
    minWidth: '140px'
  },
  eventEditTypeBox: {
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    border: '1px solid #F0F0F0',
    borderRadius: '7px',
    opacity: 1,
    margin: '5px 0',
    padding: '0 5px',
    fontSize: '12px',
    color: '#818181',
    maxWidth: '150px',
    fontWeight: 600
  },
  subTypeBoxHeading: {
    fontSize: '11px',
    color: '#818181'
  },
  subTypeBoxContent: {
    fontSize: '10px',
    color: '#6F6F6F',
    opacity: '60%'
  },
  subTypeBoxLabel: {
    fontSize: '14px',
    color: '#6F6F6F',
    opacity: '60%'
  },
  featureFormWrapper: {
    backgroundColor: '#FCFCFC',
    padding: '0 5px',
    margin: '0 10px'
  },
  separator: {
    width: '110%',
    height: '10px',
    margin: '0 -5px',
    backgroundColor: '#FFFFFF'
  },
  eventTypeText: {
    color: '#818181',
    fontSize: '12px'
  },
  labelType: {
    color: '#818181',
    fontSize: '15px',
    justifyContent: 'flex-start'
  },
  autoEnrollmentButton: {
    padding: '0px',
    margin: '0px',
    textTransform: 'none',
    '&:hover': {
      background: 'transparent'
    }
  },
  toggleWrapper: {
    marginTop: '10px',
  },
  inputFieldWrapper: {
    display: 'flex',
    marginBottom: '10px',
  },
  fieldWidth: {
    width: '50%',
    alignItems: 'center'
  },
  fileUploadWrapper: {
    width: '100%',
    marginTop: '30px',
    border: '1px solid #70707033'
  },
  fileUploadContent: {
    display: 'flex',
    margin: '22px',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    flexWrap: 'wrap',
    '@media (max-width: 768px)': {
      flexDirection: 'column'
    }
  },
  fileUploadLabel: {
    display: 'flex',
    color: '#545455',
    fontSize: '14px'
  },
  enrollmentConfigurationHeader: {
    color: '#F37320',
    background: '#F7F7F7',
    height: '37px',
    marginTop: '16px',
    marginBottom: '24px',
    letterSpacing: '0.6px',
    fontSize: '16px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '12px'
  },
  enrollmentConfigurationFooter: {
    color: '#545455',
    display: 'flex',
    alignItems: 'center',
    marginTop: '40px'
  },
  link: {
    color: '#F37320',
    cursor: 'pointer',
    margin: '8px 0 0 8px',
    fontSize: '14px'
  },
  formControlLabel: {
    fontSize: '14px',
    color: '#6F6F6F',
    opacity: '60%'
  },
  formGroup: {
    display: 'inline',
  },
  boxWrapper: {
    display:'flex', 
    flexDirection: 'column', 
    flexWrap: 'wrap',

    '@media (min-width: 1240px)': {
      flexDirection: 'row',
    }
  },
  formContentWrapper: {
    display: 'flex',
    width: '97%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    backgroundColor: '#FCFCFC',
    '@media (min-width: 768px)': {
      flexDirection: 'column',
    }
  },
  formSwitch1: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '37%',
    margin: '0px 0px 10px 20px',
  },
  sectionWrapper: {
    width: '100%',
    '@media (min-width: 768px)': {
      width: '50%'
    }
  },
  csipSectionWrapper: {
    width: '100%',
    '@media (min-width: 1240px)': {
      width: '50%'
    }
  }

}))

export { useStyles }
